export default __webpack_public_path__ + "static/media/buttonActionActive.41cb427b.svg";